var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',[_c('label',[_vm._v("API Key")]),(_vm.loading)?_c('div',[_vm._v("Please wait...")]):_c('div',[(_vm.hasKey)?_c('div',[_vm._v(" "+_vm._s(_vm.key)+" ")]):_c('md-button',[_vm._v("Create API Key")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }